import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BootstrapModule } from '../modules/bootstrap.module';
import { AlertComponent } from './alert/alert.component';
import { SpinnerComponent } from './spinner/spinner.component';
////////////////////////////////////////////////////////////////
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@NgModule({
  declarations: [
    AlertComponent,
    SpinnerComponent
  ],
  imports: [
    CommonModule,
    BootstrapModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    FormsModule,
  ],
  exports: [
    NgxSpinnerModule,
    AlertComponent,
    SpinnerComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UIModule { }
